import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { TimberService } from '@logging/timber.service';

const MODULE_NAME = 'IteroPlatformLoginGuard';

export const iteroPlatformLoginGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
	const timberService = inject(TimberService);

	const stateParam = route?.queryParamMap?.get('state');
	const loginHintParam = route?.queryParamMap?.get('login_hint');
	const sessionIdParam = route?.queryParamMap?.get('session_id');

	if (!stateParam || !loginHintParam || !sessionIdParam) {
		timberService.info(
			`Login callback missing required query params. state: ${!!stateParam}, ` +
				`login_hint: ${!!loginHintParam}, session_id: ${!!sessionIdParam}`,
			{ module: MODULE_NAME }
		);

		return false;
	}

	timberService.info('Login callback route allowed.', { module: MODULE_NAME });

	return true;
};
